<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">{{ dialogTitle }}</div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                     <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">{{ dialogTitle }}</div>
                                </div>
                                <div class="inner-panel-dialog">
                                    <dialogtree
                                        v-bind:initialData="appData.tenantList"
                                        @on-selectnode="handleOnSelectNode"
                                        :selectionType="objectType"
                                        :showAdminUser="showAdminUser"
                                        ref="dialogTree">
                                    </dialogtree>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">{{ selectedItem }}</div>
                                </div>
                                <div class="selected-item-field" style="height: calc(100% - 40px)">
                                    <div class="inner-panel-dialog">
                                        <div class="default-message" v-if="showDestinationNodeHint & (destinationNode == null)"  v-t="'message.hint_selection_move_destination'">
                                        </div>
                                        <div v-if="selectedObjectName != null" class="userTag">
                                            <span>{{ selectedObjectName }}</span>
                                            <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('close', objectType, null)" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('close', objectType, selectedObjectName)" v-t="'message.button_save'" :disabled="disableButton"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import DialogTree from "./DialogTree.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
        return {
            selectedObjectName: null,
            disableButton: true,
            dialogTitle: null,
            selectedItem: null
        };
    },
    methods: {
        handleOnSelectNode(data,selectedNode) {
            if (data.type == this.objectType) {
                switch(data.type) {
                    case constants.OBJECT_USER:
                        if (data.id == constants.SAML_ADMIN_USER_ID) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_assign_to_admin"));
                            return;
                        }
                        this.selectedObjectName = data.name
                        break;
                    case constants.OBJECT_NODE:
                        this.selectedObjectName = data.label
                        break;
                    case constants.OBJECT_TALKGROUP:
                        this.addSelectedGroupAfterOptionCheck(data.label);
                        break;
                }
                this.disableButton = false;
            }
        },
        removeUserTag: function(tag) {
            this.selectedObjectName = null;
            this.disableButton = true;
        },
        addSelectedGroupAfterOptionCheck(groupName) {
            let self = this;
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, name: groupName, type: constants.OBJECT_TALKGROUP, userTalkgroupInfo: false }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let option = res.data.talkgroupOptions
                        if (option.speechToTextEngine || option.translationEngine || option.video || option.mapTalk) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_assign_to_saml_group"));
                            return;
                        }
                        this.selectedObjectName = groupName;
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addSelectedGroupAfterOptionCheck").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "addSelectedGroupAfterOptionCheck", error);
            });
        }
    },
    components: {
        dialogtree: DialogTree
    },
    watch: {
    },
    created: function() {
        let object;
        let objectType;
        switch(this.objectType) {
            case constants.OBJECT_NODE:
                object = commonUtil.getMessageText(this.$i18n,"item_saml_layer");
                objectType = commonUtil.getMessageText(this.$i18n,"item_layer");
                break;
            case constants.OBJECT_USER:
                object = commonUtil.getMessageText(this.$i18n,"item_saml_adminId");
                objectType = commonUtil.getMessageText(this.$i18n,"item_user");
                break;
            case constants.OBJECT_TALKGROUP:
                object = commonUtil.getMessageText(this.$i18n,"item_saml_group");
                objectType = commonUtil.getMessageText(this.$i18n,"item_group");
                break;
        }
        this.dialogTitle = commonUtil.getMessageText(this.$i18n,"title_object_selection").replace("{object}",object);
        this.selectedItem = commonUtil.getMessageText(this.$i18n,"item_selected_object").replace("{object}",objectType);
    },
    props: {
        appData: Object,
        objectType: Number,
        showAdminUser: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
